/**
 *
 */

function init() {
	console.log("stickyElements");
}

// fixed sticky
//-------------------------------

function fixedStickyElement($stickyElement, $spacingElement) {
	const $window = $(window);

	const scrollTop = $window.scrollTop();
	const windowHeight = $window.height();

	if ($stickyElement.length) {
		const spacingElementTop = Math.round($spacingElement.offset().top);
		const stickyElementHeight = $stickyElement.outerHeight();

		const stickyOffset = windowHeight - (spacingElementTop - scrollTop) - stickyElementHeight;

		if (stickyOffset > 0) {
			$spacingElement.height(0);
			$stickyElement.removeClass("is-fixed");
			$spacingElement.removeClass("is-fixed");
		} else {
			$spacingElement.height($stickyElement.height());
			$stickyElement.addClass("is-fixed");
			$spacingElement.addClass("is-fixed");
		}
	}
}

export { init, fixedStickyElement };
